import { Link } from "react-scroll";
import logo from "./../assets/logo.png";

const navigationSection = [
  { name: "Sobre mí", to: "sobremi" },
  { name: "Servicios", to: "servicios" },
  { name: "Certificados", to: "certificados" },
  { name: "Testimonios", to: "testimonios" },
  { name: "Contacto", to: "contacto" },
];

export default function Footer() {
  return (
    <footer className="text-white overflow-hidden" style={{ backgroundColor: '#1e1b4b' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-10">

        {/* Top section */}
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-8 lg:gap-16 mb-12">

          {/* Brand */}
          <div className="flex flex-col items-center lg:items-start text-center lg:text-left flex-shrink-0">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-3 mb-4">
              <img src={logo} alt="Logo Barbara Zamora" className="h-16 w-16" />
            </div>
            <h3 className="font-heading text-xl font-semibold text-white">Barbara Zamora Tapia</h3>
            <div className="flex flex-col sm:flex-row gap-2 mt-2">
              <span className="inline-flex items-center gap-1.5 bg-primary/30 text-primary-light font-body text-xs font-semibold px-3 py-1 rounded-full">
                <span className="w-1.5 h-1.5 bg-primary-light rounded-full" />
                Terapeuta Ocupacional
              </span>
              <span className="inline-flex items-center gap-1.5 bg-ocean/30 text-ocean-light font-body text-xs font-semibold px-3 py-1 rounded-full">
                <span className="w-1.5 h-1.5 bg-ocean-light rounded-full" />
                Profesora de Natación
              </span>
            </div>
          </div>

          {/* Divider */}
          <div className="hidden lg:block w-px h-24 bg-white/10 self-center" />

          {/* Nav */}
          <div className="flex-1">
            <p className="font-heading text-white/70 text-xs uppercase tracking-widest mb-4 text-center lg:text-left">Navegación</p>
            <nav className="flex flex-wrap justify-center lg:justify-start gap-2" aria-label="Footer">
              {navigationSection.map((item) => (
                <Link
                  key={item.name}
                  to={item.to}
                  smooth={true}
                  duration={800}
                  className="cursor-pointer font-body font-semibold text-sm text-white/90 hover:text-white hover:bg-white/10 px-4 py-2 rounded-xl transition-all duration-200 select-none"
                >
                  {item.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* CTA */}
          <div className="flex flex-col items-center lg:items-end gap-3 flex-shrink-0">
            <p className="font-heading text-white/70 text-xs uppercase tracking-widest">Contáctame</p>
            <a
              href="https://api.whatsapp.com/send?phone=56966088903&text="
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-warm hover:bg-orange-500 text-white font-body font-bold px-6 py-3 rounded-2xl transition-all duration-200 hover:scale-105 shadow-soft cursor-pointer text-sm"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
              WhatsApp
            </a>
            <a
              href="mailto:Bczamora96@gmail.com"
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white font-body font-semibold px-6 py-3 rounded-2xl transition-all duration-200 hover:scale-105 cursor-pointer text-sm"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              Bczamora96@gmail.com
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-white/10 mb-6" />

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/70 font-body text-xs">
            © {new Date().getFullYear()} Barbara Zamora Tapia. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 bg-mint rounded-full animate-pulse" />
            <span className="text-white/70 font-body text-xs">Disponible para nuevos pacientes</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
